import React, { useState, useEffect, useCallback } from 'react';
import { theme, t } from '../theme';
import * as bio from '../platform/biometrics';
import { getPlugin } from '../platform/native';

// Volta a pedir a digital depois deste tempo em segundo plano. Curto demais
// irrita (trocar de app para copiar um endereco ja pediria de novo); longo
// demais nao protege. 2 minutos e o meio que apps de banco costumam usar.
const SEGUNDOS_ATE_TRANCAR = 120;

/**
 * Tranca local do app. So faz algo quando:
 *   - roda no app nativo, com biometria cadastrada, e
 *   - a usuaria ligou a opcao em Configuracoes.
 *
 * Nao substitui o login. Protege o que a sessao persistente expos: qualquer
 * pessoa com o celular desbloqueado abriria o Metria e veria faturamento,
 * clientes e custos.
 */
export default function BiometricGate({ children }) {
  const precisa = bio.disponivel() && bio.ativa();
  const [liberado, setLiberado] = useState(!precisa);
  const [tentando, setTentando] = useState(false);
  const [falhou, setFalhou] = useState(false);

  const pedir = useCallback(async () => {
    if (tentando) return;
    setTentando(true);
    const r = await bio.autenticar();
    setTentando(false);
    if (r.ok) { setLiberado(true); setFalhou(false); return; }
    // Cancelou ou falhou: mantem trancado e oferece tentar de novo. Nao
    // deslogamos — a credencial continua valida, so nao mostramos a tela.
    setFalhou(true);
  }, [tentando]);

  // Primeira abertura
  useEffect(() => {
    if (precisa) pedir();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [precisa]);

  // Re-tranca ao voltar do segundo plano depois do tempo limite
  useEffect(() => {
    if (!precisa) return;
    const App = getPlugin('App');
    if (!App) return;
    let saiuEm = null;
    const h = App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) { saiuEm = Date.now(); return; }
      if (saiuEm && (Date.now() - saiuEm) / 1000 > SEGUNDOS_ATE_TRANCAR) {
        setLiberado(false);
        setFalhou(false);
        pedir();
      }
      saiuEm = null;
    });
    return () => { Promise.resolve(h).then(x => x && x.remove && x.remove()).catch(() => {}); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [precisa]);

  if (liberado) return children;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 3000, background: theme.colors.bg,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: 24, textAlign: 'center', gap: 14,
    }}>
      <img src="/metria-icon.svg" alt="" style={{ width: 72, height: 72 }} />
      <div style={{ fontSize: 17, fontWeight: 700, color: theme.colors.text }}>Metria está bloqueado</div>
      <div style={{ fontSize: 14, color: theme.colors.textSecondary, maxWidth: 300 }}>
        {falhou
          ? 'Não confirmei sua identidade. Toque para tentar de novo.'
          : 'Confirme sua digital para continuar.'}
      </div>
      <button type="button" onClick={pedir} disabled={tentando}
        style={{ ...t.btnPrimary, marginTop: 6, opacity: tentando ? 0.6 : 1 }}>
        {tentando ? 'Aguardando…' : 'Desbloquear'}
      </button>
    </div>
  );
}
